import Loadable from 'react-loadable';

import LoadingModal from 'modals/LoadingModal';

export const GradProgramContactModalContainerLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "GradProgramContactModalContainer" */
      './GradProgramContactModalContainer.dynamic'
    ),
  loading: LoadingModal,
});
